import {Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {Article} from "../../shared/models/article.model";
import {GlobalEventService} from "../../shared/services/global-event/global-event.service";

@Component({
  selector: 'app-board-list',
  templateUrl: './board-list.component.html',
  styleUrls: ['./board-list.component.scss']
})
export class BoardListComponent {
  @HostBinding('style.display') styleBlock = 'block';
  @HostBinding('style.height') styleWidth = '100%';
  @Input() listArticle: Array<Article> | null = null;
  @Input() selectedNo: number | null = null;
  @Output() selectArticle = new EventEmitter<number>();

  constructor(
    private globalEventSvc: GlobalEventService,
  ) {
  }

  protected onSelect($event: MouseEvent, article_no: number) {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    console.log('BoardListComponent::onSelect()', article_no);
    this.selectArticle.emit(article_no);
  }
}
